
















































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { UtentesListRow } from '@/plugins/dbClass';
import { conection, LongPollLog } from "@/plugins/utils/conectionUtils";
import TitleArea from '@/components/TitleArea.vue';
import { copyArrayJson, timeTruncSecond, timeStringToTime, GenerateFriendlyName, dateStringToDateDate, checkRecepcao, checkDoc } from "@/plugins/utils/utils";
import { marcacaoPresenca, MarcacoesHoje } from "@/plugins/utils/marcacaoUtils";
import { pad } from '../plugins/utils/utils';

type ConsultaProc = {
  id_utente: number;
  id_cartao: number;
  id_consulta: number;
  nome: string;
  nome_pesquisa: string;
  data_consulta: string;
  telefone: string;
  codigo: string;
  diagnostico: string;
  diagnostico_pesquisa: string;
}
type ConsultasHoje = {
  id: number;
  hora: string | null;
  data: string;
  nome: string;
  id_utente: number;
  telefone: string;
  codigo: string;
  nome_pesquisa: string;
  status: number;
}
type ConsultasByDay = {
  data: string;
  itens: ConsultasHoje[];
}
type responseHome = {
  consultasproc: ConsultaProc[];
  marcacoeshoje: MarcacoesHoje[];
  consultas: ConsultasByDay[];
  terapeutas: TerapeutaSelect[];
  last_log_id: number;
}
type TerapeutaSelect = {
  id: number;
  nome: string;
}

@Component({
  components: {
    TitleArea
  }
})
export default class Utentes extends Vue {

  search = "";
  utentes: Array<UtentesListRow> = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers: Array<any> = [
    {
      text: "Nome",
      align: 'start',
      sortable: true,
      value: 'nome',
    },
    {
      text: "Telefone",
      align: 'start',
      sortable: true,
      value: 'telefone',
    },
    {
      text: "Código",
      align: 'start',
      sortable: true,
      value: 'codigo',
    },
    {
      text: "Data Consulta",
      align: 'start',
      sortable: true,
      value: 'ultima_consulta',
    },
    {
      text: "Info. Espera",
      align: 'start',
      sortable: false,
      value: 'info_espera',
    },
    {
      text: "Saltar",
      align: 'center',
      sortable: false,
      value: 'saltar',
    },
    {
      text: "Processar",
      align: 'center',
      sortable: false,
      value: 'processar',
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers_marc: Array<any> = [
    {
      text: "Hora",
      align: 'start',
      sortable: false,
      value: 'hora',
    },
    {
      text: "Nome",
      align: 'start',
      sortable: false,
      value: 'nome',
    },
    {
      text: "Telefone",
      align: 'start',
      sortable: false,
      value: 'telefone',
    },
    {
      text: "Terapeuta",
      align: 'start',
      sortable: false,
      value: 'terapeuta',
    },
    {
      text: "Longo/Pesado",
      align: 'center',
      sortable: false,
      value: 'flag_especial',
      class: "notprint"
    },
    {
      text: "Data Fim Transporte",
      align: 'center',
      sortable: false,
      value: 'data_fim_transporte',
      class: "notprint"
    },
    {
      text: "Sessões",
      align: 'center',
      sortable: false,
      value: 'status',
      class: 'notprint'
    },
    {
      text: "Presença",
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: "Falta",
      align: 'center',
      sortable: false,
      value: 'status'
    },
    {
      text: "+Info",
      align: 'center',
      sortable: false,
      value: "info",
      class: "notprint"
    },
  ];
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers_consultas: Array<any> = [
    {
      text: "Nome",
      align: 'start',
      sortable: true,
      value: 'nome',
    },
    {
      text: "Telefone",
      align: 'start',
      sortable: true,
      value: 'telefone',
    },
    {
      text: "Código",
      align: 'start',
      sortable: true,
      value: 'codigo',
    },
    {
      text: "Hora",
      align: 'start',
      sortable: true,
      value: 'hora',
    },
    {
      text: "Editar",
      align: 'center',
      sortable: false,
      value: 'editar',
    },
    {
      text: "Apagar",
      align: 'center',
      sortable: false,
      value: 'apagar',
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers_consultas2: Array<any> = [
    {
      text: "Nome",
      align: 'start',
      sortable: true,
      value: 'nome',
    },
    {
      text: "Código",
      align: 'start',
      sortable: true,
      value: 'codigo',
    },
    {
      text: "Data",
      align: 'start',
      sortable: true,
      value: 'data',
    },
    {
      text: "Hora",
      align: 'start',
      sortable: true,
      value: 'hora',
    },
    {
      text: "Iniciar",
      align: 'center',
      sortable: false,
      value: 'iniciar',
    },
  ];

  get itensPage(): number {
    if( !(this.$store.getters.userData && this.$store.getters.userData.itens_pag) ){
      return 10;
    }
    else{
      return this.$store.getters.userData.itens_pag;
    }
  }


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  footerOptions: any = {
    "items-per-page-options": [this.itensPage, -1],
    "items-per-page-text": "Linhas/página",
    "items-per-page-all-text": "Todos"
  } 

  get utentesList(): UtentesListRow[] {
    return this.utentes;
  } 

  created(){
    // console.log(this.$store.getters.userData);
    this.$store.commit("setLoading",true);
    this.getHomeData();

    this.user_level = this.$store.getters.userData.nivel;
    // console.log(this.user_level);
  }

  user_level = 1000;

  checkRecepcao(level: number): boolean{
    return checkRecepcao(level);
  }
  checkDoc(level: number): boolean{
    return checkDoc(level);
  }
  

  consultasProc: ConsultaProc[] = [];
  marcacoesHoje: MarcacoesHoje[] = [];
  consultasHoje: ConsultasByDay[] = [];
  terapeutas: TerapeutaSelect[] = [];
  flag_cons_atrasadas = false;
  errorConsultas = false;
  errorMarcacoes = false;
  errorConsultasHoje = false;
  menu_days= false;
  date = new Date();
  today = this.date.getFullYear()+"-"+ pad(this.date.getMonth()+1, 2)+"-"+pad(this.date.getDate(), 2);
  data_filter = this.today;
  menu2 = false;
  data_dia = this.today;
  
  print_flag = false;
  print(){
    this.print_flag = true;
    setTimeout(() => {
      window.print();
    }, 100);
  }

  long_poll: LongPollLog | null = null;
  declareLongPoll(last_log_id: number){
    if(!this.long_poll){
      this.long_poll = new LongPollLog(last_log_id, this.getHomeData);
    }
  }
  destroyLongPoll(){
    if(this.long_poll){
      this.long_poll.cancel();
    }
    this.long_poll = null;
  }
  destroyed(){
    this.destroyLongPoll();
  }
  getHomeData(){
    if(this.long_poll){
      this.long_poll.cancel();
    }
    conection(
      "getHomeData.php",
      {data: this.data_dia},
      (rBody: responseHome) => {
        // console.log(rBody);
        if(rBody.consultasproc){
          this.consultasProc =  copyArrayJson(rBody.consultasproc);
          this.errorConsultas = false;
        } else {
          this.errorConsultas = true;
        }
        if(rBody.marcacoeshoje){
          // console.log(rBody.marcacoeshoje);
          this.marcacoesHoje = copyArrayJson(rBody.marcacoeshoje);
          this.errorMarcacoes = false;
        } else {
          this.errorMarcacoes = true;
        }
        if(rBody.consultas){
          // console.log(rBody.consultas);
          this.consultasHoje = copyArrayJson(rBody.consultas);

          // verificar se existe alguma consulta atrasada
          for (let index = 0; index < this.consultasHoje.length; index++) {
            const element = this.consultasHoje[index];
            if(element.data < this.today){
              this.flag_cons_atrasadas = true;
              index = this.consultasHoje.length;
            }
          }
          this.errorConsultasHoje = false;
        } else {
          this.errorConsultasHoje = true;
        }
        if(rBody.terapeutas){
          this.terapeutas = copyArrayJson(rBody.terapeutas);
        }
        this.$store.commit("setLoading",false);

        this.declareLongPoll(rBody.last_log_id ? rBody.last_log_id : 1);

        if(this.long_poll){
          this.long_poll.cancel();
          this.long_poll.setCounter(1000);
        }
      },
      () => {
        // console.info("error", code);
        this.$store.commit("setLoading",false);
        this.errorConsultas = true;
        this.errorMarcacoes = true;
        this.errorConsultasHoje = true;
      }
    );
  }

  get consultas(): ConsultaProc[] {
    return this.consultasProc;
  }
  get marcaoes(): MarcacoesHoje[] {
    return this.marcacoesHoje;
  }
  
  get consultasDay(): ConsultasHoje[] {
    for (let i = 0; i < this.consultasHoje.length; i++) {
      const element = this.consultasHoje[i];
      if(element.data == this.data_filter){
        i = this.consultasHoje.length;
        return element.itens;
      }
    }
    return [];
  }

  get consultasToday(): ConsultasHoje[] {
    // for (let i = 0; i < this.consultasHoje.length; i++) {
    //   const element = this.consultasHoje[i];
    //   if(element.data == this.today){
    //     i = this.consultasHoje.length;
    //     return element.itens;
    //   }
    // }
    // return [];
    const itens: ConsultasHoje[] = []; 
    for (let i = 0; i < this.consultasHoje.length; i++) {
      const element = this.consultasHoje[i];
      if(element.data <= this.today){
        // i = this.consultasHoje.length;
        // return element.itens;
        element.itens.forEach(item => {
          itens.push(item);
        })
      }
    }
    // return [];
    return itens;
  }

  allowedDates(val: string): boolean {
    let flag = false;
    for (let i = 0; i < this.consultasHoje.length; i++) {
      const element = this.consultasHoje[i];
      if(element.data == val){
        i = this.consultasHoje.length;
        flag = true;
      }
    }

    return flag;
  }

  truncateTime(time: string): string{
    return timeTruncSecond(time);
  }
  
  checkTimePassed(time_string: string): boolean{
    const time = timeStringToTime(time_string);
    const nowDate = new Date();
    nowDate.setMinutes( nowDate.getMinutes() - 30 );
    const now = nowDate.getTime();
    if(time < now){
      return true;
    }
    else {
      return false;
    }
  }

  marcacaoPresenca(item: MarcacoesHoje): void{
    this.$store.commit("setLoading", true);
    marcacaoPresenca(
      item.id,
      item.status,
      item.data,
      () => {
        let string_feedback = "Presença assinalada";
        if(item.status == 0) string_feedback = "Presença retirada"; 
        this.$store.commit("setError", {flag: true, text: string_feedback, status: "success"});
        this.getHomeData();
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Ocorreu um erro a assinalar/retirar a presença! Tente de novo", status: "error"});
        this.$store.commit("setLoading", false);
        item.status = item.status*(-1)+1;
      }
    );
  }

  marcacaoFalta(item: MarcacoesHoje): void{
    this.$store.commit("setLoading", true);
    conection(
      "togleFalta.php",
      {id_marcacao: item.id, falta: item.falta, data: item.data},
      () => {
        let string_feedback = "Falta assinalada";
        if(item.falta == 0) string_feedback = "Falta retirada"; 
        this.$store.commit("setError", {flag: true, text: string_feedback, status: "success"});
        this.getHomeData();
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Ocorreu um erro a assinalar/retirar a falta! Tente de novo", status: "error"});
        this.$store.commit("setLoading", false);
        item.falta = item.falta*(-1)+1;
      }
    );
  }

  populateUtentes(itens: Array<UtentesListRow>): void{
    this.utentes = itens;
    this.$store.commit("setLoading",false);
  }

  flag_popup_delete = false;
  remove_id_consulta: number | null = null;

  clearApagarConsulta(){
    this.flag_popup_delete = false;
    this.remove_id_consulta = null;
  }
  
  apagarConsulta(id_consulta: number): void{
    conection(
      "deleteConsulta.php",
      {id_consulta: id_consulta},
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      () => {
        this.$store.commit("setError", {flag: true, text: "Consulta apagada com sucesso!", status: "success"});
        this.getHomeData();
        this.clearApagarConsulta();
        this.$store.commit("setLoading", false);
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Erro ao apagar Consulta!", status: "error"});
        this.$store.commit("setLoading", false);
      }
    )
  }

  flag_popup_saltar = false;
  saltar_id_consulta: number | null = null;
  clearSaltarConsulta(){
    this.flag_popup_saltar = false;
    this.saltar_id_consulta = null;
  }
  saltarConsulta(id_consulta: number): void{
    conection(
      "saltarConsulta.php",
      {id_consulta: id_consulta},
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      () => {
        this.$store.commit("setError", {flag: true, text: "Consulta assinalada como tratada com sucesso!", status: "success"});
        this.getHomeData();
        this.clearSaltarConsulta();
        this.$store.commit("setLoading", false);
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Erro ao assinalar Consulta!", status: "error"});
        this.$store.commit("setLoading", false);
      }
    )
  }

  

  // PESQUISA
  search_proc = "";
  get consultasListSearc(): ConsultaProc[]{
    return this.consultas.filter(item => {
      if(!this.search_proc || this.search_proc.length < 3){
        return true;
      }
      else {
        const key_array: string[] = this.search_proc.trim().split(" ");
        // console.log(key_array);
        let flag_found = 0;
        key_array.forEach(value => {
          const new_value: string = GenerateFriendlyName(value);
          if(!item.nome_pesquisa){
            item.nome_pesquisa = GenerateFriendlyName(item.nome);
          }
          
          if(
            (item.nome_pesquisa && item.nome_pesquisa.includes(new_value)) ||
            (item.codigo && item.codigo == value) || 
            (item.telefone && item.telefone.includes(value))
          ){
            flag_found++;
          }

        });

        if(flag_found > 0 && flag_found == key_array.length){
          return true;
        }
        else {
          return false;
        }
      }
    });
  }

  search_marc = "";
  terapeutaSel: number | null = null;
  get marcacoesListSearc(): MarcacoesHoje[]{
    return this.marcacoesHoje.filter(item => {
      if(!this.search_marc || this.search_marc.length < 3){
        if(
          (this.terapeutaSel != null && item.id_terapeuta == this.terapeutaSel) || 
          this.terapeutaSel == null
        ){
          return true;
        }
        else {
          return false;
        }
      }
      else {
        const key_array: string[] = this.search_marc.trim().split(" ");
        // console.log(key_array);
        let flag_found = 0;
        key_array.forEach(value => {
          const new_value: string = GenerateFriendlyName(value);
          if(!item.nome_pesquisa){
            item.nome_pesquisa = GenerateFriendlyName(item.nome);
          }
          if(!item.diagnostico_pesquisa && item.diagnostico){
            item.diagnostico_pesquisa = GenerateFriendlyName(item.diagnostico);
          }
          
          if(
            (item.nome_pesquisa && item.nome_pesquisa.includes(new_value)) ||
            (item.codigo && item.codigo == value) || 
            (item.diagnostico_pesquisa && item.diagnostico_pesquisa.includes(new_value) ) || 
            (item.telefone && item.telefone.includes(value))
          ){
            flag_found++;
          }

        });

        if(flag_found > 0 && flag_found == key_array.length){
          if(
            (this.terapeutaSel != null && item.id_terapeuta == this.terapeutaSel) || 
            this.terapeutaSel == null
          ){
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return false;
        }
      }
    });
  }

  checkTimeToDate(date: string): number{ 
    let numberDays = 1000;
    if(date){
      const newDate = dateStringToDateDate(date).getTime();
      const today = new Date().getTime();
      const diference = ( (newDate-today) / 1000 ) / 60 / 60 / 24;
      numberDays =  diference;
    }

    return numberDays;
  }
}
